import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { UserAccounts } from 'src/app/interfaces/account';
import { ModalController } from '@ionic/angular';
import { SupportTicketType } from 'src/app/types/support';
import { AccountsListType } from 'src/app/types/accounts';
import { AccountsListService } from 'src/app/services/accounts/accounts-list.service';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

@Component({
  selector: 'app-accounts-list',
  templateUrl: './accounts-list.component.html',
  styleUrls: ['./accounts-list.component.scss'],
})
export class AccountsListComponent implements OnInit, OnDestroy {

  @ViewChild(CdkVirtualScrollViewport) cdkVirtualScrollViewport: CdkVirtualScrollViewport;
  /**
   * User account list
   */
  userAccountsList: UserAccounts[];
  selected: string;
  supportTicktType: SupportTicketType;
  /**
   * User account list subscription
   */
  private userAccountsListSubscription: Subscription;

  constructor(
    private modalController: ModalController,
    private accountsListService: AccountsListService,
  ) { }

  ngOnInit() {}

  ngOnDestroy() {
    this.unwatchUserAccountsList();
  }

  ionViewWillEnter(){
    this.accountsListService.watchUserAccountsList();
    this.watchUserAccountsList();
  }

  ionViewWillLeave() {
    this.accountsListService.unwatchUserAccountsList();
    this.unwatchUserAccountsList();
  }

  /**
   * Watch account list
   */
  async watchUserAccountsList() {
    if (!this.userAccountsListSubscription) {
      this.userAccountsListSubscription = this.accountsListService.observableUserAccountsList
      .subscribe((userAccountsList: UserAccounts[]) => {
        if (userAccountsList?.length) {
          this.loadAccountsList();
        }
      });
    } 
  }

  /**
   * Unwatch account list
   */
  async unwatchUserAccountsList() {
    if (this.userAccountsListSubscription) {
      this.userAccountsListSubscription.unsubscribe();
      this.userAccountsListSubscription = null;
    }
  }

  /**
   * Load user account list
   */
  async loadAccountsList() {
    const accountsListType: AccountsListType = this.supportTicktType === 'refund' ? 'refund' : 'all';
    this.userAccountsList = this.accountsListService.searchAccountsList(null, accountsListType);
    this.setupViewport();
  }

  setupViewport() {
    if (this.cdkVirtualScrollViewport) {
      setTimeout(() => {
        this.cdkVirtualScrollViewport?.checkViewportSize();
      }, 200);
    } else {
      setTimeout(() => {
        this.setupViewport();
      }, 200);
    }
  }

  /**
   * Check if category is selected
   * @param category category
   */
  checkSelected(accountId: string): boolean {
    if (this.selected && this.selected === accountId) {
      return true;
    }
    return false;
  }

  /**
   * Select category, prompt edit for setting mode, else dimiss current modal for selection.
   * @param category category
   * @param index index of selected category
   */
  select(userAccounts: UserAccounts) {
    this.selected = userAccounts?.accountId;
    this.dismissModal(this.selected);
  }

  /**
   * Dismiss category modal
   * @param selected Selected category
   */
  async dismissModal(selected?: string) {
    if (this.modalController) {
      const modal = await this.modalController.getTop();
      if (modal) { modal.dismiss({ selected }); }
    }
  }

  /**
   * Track item
   * @param index Index
   * @param item item
   */
  trackByFn(index: number, item: UserAccounts) {
    if (item?.accountId) {
      return item.accountId;
    }
    return index;
  }

}
